import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// Enums
import { AuthorizationOperations } from '../enums/authorization-operations.enum';
import { AuthorizationTypes } from '../enums/authorization-types.enum';
import { AuthorizationResourceKey } from '../enums/authorization-resource-key.enum';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {
  constructor(private httpClient: HttpClient) {}

  /**
   * Check if user authorized by resourceId
   * @param resourceId id of used resource
   * @param operation want to do
   */
  public isAuthorizedById(resourceId: string, operation: AuthorizationOperations): Observable<boolean> {
    const url = environment.services.structure + '/authorization/id/' + resourceId + '/' + operation;

    return this.httpClient.get<boolean>(url);
  }

  /**
   * Check if user authorized by resourceKey
   * @param type for resource key
   * @param resourceKey key of resource
   * @param operation want to do
   */
  public isAuthorizedByKey(
    type: AuthorizationTypes,
    resourceKey: AuthorizationResourceKey,
    operation: AuthorizationOperations
  ): Observable<boolean> {
    const url = environment.services.structure + '/authorization/' + type + '/' + resourceKey + '/' + operation;

    return this.httpClient.get<boolean>(url);
  }
}
